import {
  ORDER_STATUS_COMPLETED,
  ORDER_STATUS_DELIVERING,
  ORDER_STATUS_PREPARED,
  ORDER_STATUS_PREPARING,
  ORDER_STATUS_PROCESSING,
} from '../../../../utility/constants';
import {
  calculateAgoSeconds,
  capitalize,
  getNextOrderStatus,
} from '../../../../utility/util/util.service';

export const created2OrMoreDaysAgo = (timestamp) =>
  Math.abs(calculateAgoSeconds(timestamp)) > 2 * 60 * 60;

export const isPendingOrderStatus = (status) =>
  [
    ORDER_STATUS_PROCESSING,
    ORDER_STATUS_DELIVERING,
    ORDER_STATUS_PREPARING,
    ORDER_STATUS_PREPARED,
  ].includes(status);

export const getAdminButtonText = (intl, order) => {
  const nextStatus = getNextOrderStatus(order.status, order.type);
  const nextStatusSuffix =
    capitalize(nextStatus) +
    (nextStatus === ORDER_STATUS_PREPARED || ORDER_STATUS_DELIVERING
      ? 'Ago@' + order.type
      : '');
  const id = 'orderStatus' + nextStatusSuffix;

  return intl.formatMessage(
    { id: 'changeStatusTo' },
    {
      status: intl.formatMessage({ id: id }, { ago: '' }),
    },
  );
};
